import config from "@/config.js";

export const userModule = {
    state: () => ({
        isLoader: false,
        error: null,
        user: null,
    }),
    mutations: {
        setUser(state, data) {
            state.user = data;
        },
        setError(state, data) {
            state.error = data;
        },
        setLoader(state, data) {
            state.isLoader = data;
        },
    },
    getters: {
        isAuthorized(state) {
            return !!state.user;
        }
    },
    actions: {
        logout({state, commit}) {
            localStorage.removeItem('user_id');
            state.user_id = null;
            this.$router.push({name: 'index'});
        },
        async getCurrentUser({commit}) {
            commit('setLoader', true);
            let axiosConfig = {
                headers: {
                    'Content-Type': 'application/json',
                }
            };
            await this.$API.request.get(config.hostname + '/index.php?route=api/customer', axiosConfig).then((response) => {
                commit('setUser', response.customer);
            }).catch((error) => {
                commit('setError', error.response?.data?.error)
            }).finally(() => {
                commit('setLoader', false);
            })
        }
    },
    namespaced: true
}
